var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.614 0.210694C12.0499 0.549764 12.1284 1.17804 11.7894 1.61399L5.95604 9.11399C5.78921 9.32849 5.54227 9.46585 5.27204 9.49448C5.00181 9.52311 4.73157 9.44053 4.5235 9.26575L0.356831 5.76575C-0.0660562 5.41053 -0.120907 4.77974 0.234318 4.35685C0.589543 3.93397 1.22033 3.87912 1.64322 4.23434L5.01482 7.06649L10.2107 0.386105C10.5497 -0.0498418 11.178 -0.128376 11.614 0.210694Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.ce89e283.svg";
export { ForwardRef as ReactComponent };